import Date from "../../../../data/fieldRenderers/Date";
import Duration from "../../../../data/fieldRenderers/Duration";
import ID from "../../../../data/fieldRenderers/ID";
import Resource from "../../../../data/fieldRenderers/Resource";
import Tag from "../../../../data/fieldRenderers/Tag";
import TruncatedStringList from "../../../../data/fieldRenderers/TruncatedStringList";
import type { FieldRenderers } from "../../../../data/types";
import AccessRequestState from "./AccessRequestState";
import type { DataType } from "./fields";

const fieldRenderers: FieldRenderers<DataType> = {
  Date,
  Duration,
  ID,
  Recipients: TruncatedStringList,
  Resource,
  State: AccessRequestState,
  Tag,
};

export default fieldRenderers;
